import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface IFiles extends File {
  path: string;
}

type State = {
  files: IFiles[];
};

type Actions = {
  addFiles: (files: File[]) => void;
  removeFile: (file: IFiles) => void;
  removeAll: () => void;
};

export const useUploadStore = create(
  immer<State & Actions>((set) => ({
    files: [],
    addFiles: (files) => set(() => ({ files })),
    removeFile: (file) => set((state) => ({
      files: state.files.filter((_f) => _f.path !== file.path),
    })),
    removeAll: () => set({ files: [] }),
  })),
);
